import { render } from "./CreateTyreReviewForm.vue?vue&type=template&id=513c331b"
import script from "./CreateTyreReviewForm.vue?vue&type=script&lang=js"
export * from "./CreateTyreReviewForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__